<template>
    <div>
        <div class="fin-w-full md:fin-max-w-60 fin-pl-5 fin-text-center md:fin-hidden" v-if="currentPageName !== 'welcome' && !_.isEmpty(groupData)">
            <i v-if="_.get(groupData, 'icon')" :class="_.get(groupData, 'icon')"></i>
            <h3 class="fin-text-[10px] fin-ml-2">{{ _.get(groupData, 'title') }}</h3>
        </div>

        <div class="fin-w-full md:fin-max-w-60 fin-pl-5 fin-hidden md:fin-block" v-if="currentPageName !== 'welcome' && !_.isEmpty(groupData)">
            <div class="fin-flex fin-items-center fin-justify-start sm:fin-justify-end">
                <i v-if="_.get(groupData, 'icon')" :class="_.get(groupData, 'icon')"></i>
                <h3 class="fin-text-xs fin-ml-2">{{ _.get(groupData, 'title') }}</h3>
            </div>
            <div class="fin-text-left sm:fin-text-right">
                <p class="fin-text-[10px]">{{ _.get(groupData, 'description') }}</p>
            </div>
        </div>
    </div>
</template>

<script>

import formMixin from "@tenant/app-form/mixins/formMixin"

export default {
    name: 'FormGroupMobile',

    data() {
        return {

        };
    },

    props: {
        formStore: {
            required: false,
            type: String,
            default: "formStore"
        },
    },
    
    computed: {

        groupData() {
            let formGroups = Object.assign([], this.formGroups)

            if (_.isEmpty(this.currentGroup)) {
                return formGroups[0]
            } else {

                let groupIndex = formGroups.findIndex(group => {
                    return _.kebabCase(group.title) === this.currentGroup.id
                }) 

                let group = formGroups[groupIndex]
                if (group && !_.isEmpty(this.currentGroup.description)) {
                    group.description = this.currentGroup.description
                }

                return group
            }
        }
    },

    mixins: [formMixin],

    mounted() {

    },

    methods: {

    },
};
</script>

<style lang="scss" scoped>

</style>
